import { motion } from "framer-motion";
import { ClipboardList, MapPin, FileCheck, Hammer } from "lucide-react";

const STEPS = [
  {
    icon: ClipboardList,
    title: "1. Anfrage",
    text: "Sie schildern kurz Ihr Vorhaben – über das Formular, per WhatsApp oder am Telefon.",
  },
  {
    icon: MapPin,
    title: "2. Besichtigung",
    text: "Ich schaue mir Ihr Grundstück vor Ort an und berate Sie kostenlos und unverbindlich.",
  },
  {
    icon: FileCheck,
    title: "3. Festpreis-Angebot",
    text: "Sie erhalten ein transparentes Angebot zum Festpreis – ohne versteckte Kosten.",
  },
  {
    icon: Hammer,
    title: "4. Umsetzung",
    text: "Wir setzen Ihr Projekt sauber und termingerecht um – bis zur Übergabe.",
  },
];

export default function Process() {
  return (
    <section id="ablauf" className="py-16 sm:py-24 lg:py-32 px-4 sm:px-8 lg:px-16" data-testid="process-section">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl"
        >
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#244A32]">So läuft's</p>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight mt-4">
            In vier Schritten zu Ihrem Projekt
          </h2>
          <p className="mt-4 text-base text-[#575953] leading-relaxed">
            Kein komplizierter Prozess, keine langen Wartezeiten – so einfach arbeiten wir zusammen.
          </p>
        </motion.div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map(({ icon: Icon, title, text }, i) => (
            <motion.div
              key={title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.55, delay: i * 0.12 }}
              className="relative bg-white rounded-2xl border border-[#E5E2DC] p-7 hover:shadow-xl hover:shadow-[#244A32]/10 hover:-translate-y-1 transition-all"
              data-testid={`process-step-${i + 1}`}
            >
              <div className="w-12 h-12 rounded-xl bg-[#244A32]/10 flex items-center justify-center">
                <Icon className="w-6 h-6 text-[#244A32]" />
              </div>
              <h3 className="font-heading font-semibold text-lg mt-5">{title}</h3>
              <p className="text-sm text-[#575953] mt-2 leading-relaxed">{text}</p>
              {i < STEPS.length - 1 && (
                <span className="hidden lg:block absolute top-1/2 -right-4 w-8 border-t-2 border-dashed border-[#C89D66]" aria-hidden="true" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
